<template>
    <div :class="color" class="cont">
        <div class="files">{{$t('offer_files')}}</div>
        <div class="row">
            <div class="col-lg-4" v-for="file in files" :key="file.id">
                <div class="box">
                    <a :href="file.file" class="d-flex" Download>
                        <div class="img_name">
                            <img :src="getIcon(file.ext)" :alt="file.ext">
                            <div class="mr-2 ml-2 file_name">{{ setName(file.name, file.ext) }}</div> 
                        </div>
                        <div :title="file.size" class="file_size"> {{ getFileSize(file.size) }} </div> 
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['filesprops', 'color'],
    data() {
        return {
            files: []
        }
    },
    mounted () {
        this.files = JSON.parse(this.filesprops);
    },
    methods: {
        getIcon(ext) {
            if(ext == 'pdf')
                return '/img/price/files_to_download/pdf_icon.svg'
            if(ext == 'doc' || ext == 'docx')
                return '/img/price/files_to_download/word_icon.svg'
            if(ext == 'jpeg' || ext == 'jpg' || ext == 'png')
                return '/img/price/files_to_download/img_icon.svg'

            return '/img/price/files_to_download/other_icon.svg'
        },
        getFileSize(size) {
            var fileSizeInBytes = parseFloat(size)
            var i = -1;
            var byteUnits = ['kb', 'mb'];
            do {
                fileSizeInBytes = fileSizeInBytes / 1024;
                i++;
            } while (fileSizeInBytes > 1024);
            return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
        },
        setName(value, ext){
            if(value.length > 15){
                return value.slice(0, 15)+"..."+ext;
                
            }
            return value;
        }
    },
    
}
</script>

<style lang="scss" scoped>
*{
    color: white;
}
.cont{
    padding:0 51px;
    width:100%;
    @media only screen and (max-width: 1050px){
        padding: 0px 15px;
    }
    @media only screen and (max-width: 480px){
        padding:0 15px;
    }
    .files{
        font-weight: 900;
        font-size: 20px;
        line-height: 37px;
        padding-bottom:16px;
        @media only screen and (max-width: 1000px){
            text-align: center;
        }
    }
    &.black .files{
        color: #FFFFFF;
    }
    &.white .files{
        color: #212541;
    }
    &.white .box{
        background: #FFFFFF;
        &:hover{
            background: #F2F2F2;
            text-decoration: none !important;
        }
    }
    &.black .box{
        background: #000807;
        &:hover{
            background: #02221e;
        }
    }
    &.black .file_name{
        color: #FFFFFF;
    }
    &.white .file_name{
        color:#212541;
    }
    &.black .file_size{
        color: #FFFFFF;
    }
    &.white .file_size{
        color:#212541;
    }
    .box{
        box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
        border-radius: 8px;
        width: 354px;
        height: 54px; 
        padding: 0 15px;
        transition: all .2s;
        @media only screen and (max-width: 1050px){
            width: 303px;
            padding: 0px 5px;
        }
        @media only screen and (max-width: 1000px){
            width: 354px;
            padding: 0 15px;
            margin: 0 auto 0px auto;
        }
        @media only screen and (max-width: 480px){
            width:100%;
            margin: 0 auto 15px auto;
        }
        
        a{
            align-items: center;
            justify-content:space-between;
            height: 100%;
            .img_name{
                display: flex;
                align-items: center;
                img{
                    width:30px;
                    height:30px;
                }
            }
            &:hover{
                text-decoration: none !important;
            }
            
        }
    }
}
</style>